<template lang="pug">
    .settings(v-if='settings')
        template
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}:
                | {{ $i18n.t(`trainer.trainer_gameFormSetting_${settings.type}`) }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfItemsInTheRoom') }}:
                | {{ settings.amountOfItemsInTheRoom }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInChain') }}:
                | {{ settings.amountOfWordsInChain }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_inOrder') }}:
                | {{ settings.inOrder ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf')}}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_difficultWords') }}:
                | {{ settings.difficultWords ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf')}}
            br
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
    };
</script>
